// extracted by mini-css-extract-plugin
export default {"root":"root--AuOvn","section":"section--bcEfs","groupTitle":"groupTitle--KxlQp","channelIcon":"channelIcon--tcs4C","text":"text--I9w6G","chips":"chips--oOowE","chip":"chip--Cdkxh"};